import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import * as actionCrud from "../../../crud/action.crud";
import * as calendarCrud from "../../../crud/calendar.crud";
import * as jobCrud from "../../../crud/job.crud";
import * as actionsDuck from '../../../store/ducks/actions.duck';
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import DataGrid, { Button, Column, SearchPanel, StateStoring, Export, ColumnChooser, ColumnFixing, Editing, HeaderFilter, Summary, TotalItem, Scrolling, Toolbar, Item as ToolbarItem, Selection, FilterPanel, FilterRow } from 'devextreme-react/data-grid';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { Link } from "react-router-dom";
import { getActionGroupCategories } from '../../../shared/lookup';
import { withRouter } from '../../../shared/hoc/withRouter';
import { defaultTemplate } from '../../../Templates/DefaultTemplates';
import { adjustContractTemplate } from "../../../Templates/TemplateAdjust";
import { completeActionConfirmationDialog } from "../../admin/Contracts/Contract/ContractActions";
import SystemHelper from "../../../shared/systemHelper";
import ICSCalendarHelper from '../../../shared/ICSCalendarHelper';
import ActionsCalendarSubscriptionWizard from './ActionsCalendarSubscriptionWizard';
import ActionsEmailSubscriptionWizard from './ActionsEmailSubscriptionWizard';

const genericPartyNames = [
    { id: 1, dbvalue: "Contractor", display: "Supplier" },
    { id: 2, dbvalue: "PM", display: "Contract Administrator" },
    { id: 3, dbvalue: "Supervisor", display: "Supervisor" },
    { id: 4, dbvalue: "Client", display: "Client" },
];

const dummyContract = {
    contractid: 1,
    deleted: 0,
    recordstatus: 1,
    partystructure: 3,//ALL
    contracttype: "DUMMY",
    employercompanyid: 1,
    supervisorcompanyid: 1,
    contractorcompanyid: 1,
    pmcompanyid: 1,
}
const isCalendarSubscriptionEnabled = process.env.REACT_APP_CALENDAR_SUBSCRIPTION_ENABLED === "true";
const isActionMailSubscriptionEnabled = process.env.REACT_APP_ACTION_MAIL_SUBSCRIPTION_ENABLED === "true";
class ActionsGrid extends React.Component {
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();
        this.fileImportInputRef = React.createRef();
        this.importExcelTemplateDownloadLinkRef = React.createRef();
        this.actionGroupCategories = getActionGroupCategories(this.props.intl);
        this.genericPartyNames = JSON.parse(JSON.stringify(genericPartyNames));
        this.genericPartyNames[0].display = this.props.intl.formatMessage({ id: "GENERAL.SUPPLIER_NAME" });
        this.genericPartyNames[1].display = this.props.intl.formatMessage({ id: "GENERAL.PM_NAME" });
        this.genericPartyNames[2].display = this.props.intl.formatMessage({ id: "GENERAL.SUPERVISOR_NAME" });
        this.genericPartyNames[3].display = this.props.intl.formatMessage({ id: "GENERAL.CLIENT_NAME" });
        this.dummyTemplate = adjustContractTemplate(dummyContract, defaultTemplate, null, null, true);
        this.additionalColumns = [
            {
                caption: this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.SOURCELINK" }),
                dataField: "url",
                showInColumnChooser: false,
                showInExport: true,

            }
        ];
        this.localStorageKey = process.env.REACT_APP_PRODUCT_KEY + process.env.REACT_APP_ENVIRONMENT + "_GlobalActionsGrid_5";


        this.state = {
            showCalendarSubscriptionWizard: false,
            showEmailSubscriptionWizard: false
        };

    }


    downloadExcelTemplate = async () => {
        this.importExcelTemplateDownloadLinkRef.current.click();
    }

    onExporting = (e) => {
        e.component.beginUpdate();

        const currentColumns = e.component.getVisibleColumns();
        const additionalColumnsToAdd = this.additionalColumns.filter(additionalColumn =>
            !currentColumns.some(column => column.dataField === additionalColumn.dataField)
        );

        additionalColumnsToAdd.forEach(column => {
            e.component.addColumn(column);
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            customizeCell: (options) => {
                const { gridCell, excelCell } = options;
                if (gridCell.rowType === 'data') {
                    if (['url', 'complete'].includes(gridCell.column.dataField)) {
                        const rowData = gridCell.data;
                        if (gridCell.column.dataField === 'url') {
                            const hyperlink = this.calculateLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        } else if (gridCell.column.dataField === 'complete' && this.validateComplete(gridCell.data).allowed) {
                            const hyperlink = this.calculateCompleteActionLink(rowData);
                            if (hyperlink) {
                                excelCell.value = { text: 'Link', hyperlink };
                                excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                            }
                        }
                    }
                }
            }
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ContractActions.xlsx');
                });
        }).finally(() => {
            additionalColumnsToAdd.forEach(column => {
                e.component.deleteColumn(column.dataField);
            });
            e.component.endUpdate();
        });

        e.cancel = true;
    }


    renderCreateByReference = (cellInfo) => {
        //contractid = _2
        //sourceworkflowid = _9
        //sourcerecordid = _10
        //sourcereferenceid = _11
        //resolvingchildrecordid = _14
        const wf = this.dummyTemplate.workflowsQA[cellInfo.data._9];
        if (cellInfo.data._11 && cellInfo.data._10 && wf) {
            let path = wf.paths.basePathTemplate.replace(":contractid", cellInfo.data._2) + cellInfo.data._10;
            // if (cellInfo.data.type === "SYSTEM_REPLY_QUOTE") {
            //     const quotePath = wf.config.paths.quote;
            //     path += "/" + quotePath + cellInfo.data._14;
            // }
            if (cellInfo.data._14 && wf.config.paths.quote) {
                const quotePath = wf.config.paths.quote;
                path += "/" + quotePath + "/" + cellInfo.data._14;
            }
            return (
                <Link to={path}>
                    {cellInfo.data._11}
                </Link>
            )
        }
    }

    // calculateTypeDisplayValue = (rowData) => {
    //     if (rowData.resolvingworkflowid) {
    //         return this.props.contractTemplate.workflowsQA[rowData.resolvingworkflowid]?.pageTitle;
    //     }
    //     else {
    //         return this.props.contractTemplate.availableActionTypesTypeDisplayObj[rowData.type];
    //     }
    // }

    onRowPrepared = (e) => {
        if (e.rowType === "data" && e.rowElement) {
            if (e.data?.overdue === 1) {
                e.rowElement.style.backgroundColor = '#ffcccb';
            }
            // else if(e.data?.completed){
            //     e.rowElement.style.backgroundColor = '#DFFFE9';
            // }

        }
    }
    calculateLink = (rowData) => {
        const wf = this.dummyTemplate.workflowsQA[rowData._9];

        let url = "";

        if (rowData._11 && rowData._10 && wf) {
            url = process.env.PUBLIC_URL + wf.paths.basePathTemplate.replace(":contractid", rowData._2) + rowData._10;

            if (rowData._14 && wf.config.paths.quote) {
                const quotePath = wf.config.paths.quote;
                url += "/" + quotePath + "/" + rowData._14;
            }
        }

        return url;
    }
    calculateCompleteActionLink = (rowData) => {
        let path = "";

        if (rowData._15 === 2 || rowData._15 === 6) //AWAITING_REPLY or AWAITING_ACTION
        {
            const wf = this.dummyTemplate.workflowsQA[rowData._12];
            path = wf.paths.basePathTemplate.replace(":contractid", rowData._2) + rowData._13;
        }
        else if (rowData._15 === 3) //AWAITING_RELATED_COMMUNICATION
        {
            const wf = this.dummyTemplate.workflowsQA[rowData._12];
            const createPath = wf.config.paths.create;
            path = wf.paths.basePathTemplate.replace(":contractid", rowData._2) + createPath;
        }
        else if (rowData._15 === 4) //AWAITING_QUOTATION
        {
            const wf = this.dummyTemplate.workflowsQA[rowData._12];
            path = wf.paths.basePathTemplate.replace(":contractid", rowData._2) + rowData._13;
            const quotePath = wf.config.paths.quote;
            path += "/" + quotePath + "/create";
        }
        else if (rowData._15 === 5) //AWAITING_QUOTATION_REPLY
        {
            const wf = this.dummyTemplate.workflowsQA[rowData._12];
            path = wf.paths.basePathTemplate.replace(":contractid", rowData._2) + rowData._13;
            const quotePath = wf.config.paths.quote;
            path += "/" + quotePath + "/" + rowData._14;
        }

        return path;
    }
    completeIconClicked = async (e) => {
        //[GroupCategory] = _15
        //DueDate  = _8,
        //[Subject] = _5,
        //SourceReferenceID = _11,
        //contractid = _2
        //ActionID = _1,
        //ResolvingWorkflowID = _12,
        //ResolvingRecordID = _13,
        //ResolvingChildRecordID = _14,
        const { data } = e.row;
        if (data._15 === 1) //ASSIGNED_ACTIONS
        {
            const actionItem = {
                duedate: data._8,
                subject: data._5,
                sourcereferenceid: data._11,
            }
            let result = await completeActionConfirmationDialog(actionItem, this.props.intl);
            if (result) {
                this.setState({ isBusy: true }, async () => {
                    try {
                        const requestObj = {
                            contractid: data._2,
                            actionids: [data._1]
                        }
                        const response = await actionCrud.complete(requestObj);
                        this.props.loadActions();
                    } catch (err) {
                        this.setState({ isBusy: false });
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }
                });
            }
        }
        else if (data._15 === 2 || data._15 === 6) //AWAITING_REPLY or AWAITING_ACTION
        {
            const wf = this.dummyTemplate.workflowsQA[data._12];
            let path = wf.paths.basePathTemplate.replace(":contractid", data._2) + data._13;
            this.props.navigate(path);
        }
        else if (data._15 === 3) //AWAITING_RELATED_COMMUNICATION
        {
            const wf = this.dummyTemplate.workflowsQA[data._12];
            const createPath = wf.config.paths.create;
            let path = wf.paths.basePathTemplate.replace(":contractid", data._2) + createPath;
            this.props.navigate(path);
        }
        else if (data._15 === 4) //AWAITING_QUOTATION
        {
            const wf = this.dummyTemplate.workflowsQA[data._12];
            let path = wf.paths.basePathTemplate.replace(":contractid", data._2) + data._13;
            const quotePath = wf.config.paths.quote;
            path += "/" + quotePath + "/create";
            this.props.navigate(path);
        }
        else if (data._15 === 5) //AWAITING_QUOTATION_REPLY
        {
            const wf = this.dummyTemplate.workflowsQA[data._12];
            let path = wf.paths.basePathTemplate.replace(":contractid", data._2) + data._13;
            const quotePath = wf.config.paths.quote;
            path += "/" + quotePath + "/" + data._14;
            this.props.navigate(path);
        }
    }
    // isCompleteIconVisible = (e) => {
    //     return (e.row.data._15 === 5);
    // }
    onCalendarSubscriptClick = async (e) => {
        SystemHelper.hubspotUpdateEvent("ACTIONS_SUBSCRIBE_CALENDAR");
        this.setState({ showCalendarSubscriptionWizard: true });
    }

    onCalendarSubscriptionWizardDialogResult = async (result) => {
        this.setState({ showCalendarSubscriptionWizard: false });
    }
    onEmailSubscriptClick = async (e) => {
        SystemHelper.hubspotUpdateEvent("ACTIONS_SUBSCRIBE_EMAIL");
        this.setState({ showEmailSubscriptionWizard: true });
    }

    onEmailSubscriptionWizardDialogResult = async (result) => {
        this.setState({ showEmailSubscriptionWizard: false });
    }
    customSaveState = (state) => {
        if (window.location.hash !== "#subscription" && !window.location.search) { //only save state if not in subscription view or resolving specific action view (identified by query param)
            localStorage.setItem(this.localStorageKey, JSON.stringify(state));
        }

    }
    customLoadState = () => {
        const state = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
        if(window.location.search){
            const queryParams = new URLSearchParams(window.location.search);
            let resolvingactionid = queryParams.get('resolvingactionid');
            if(resolvingactionid){
                state.filterValue = ["_1", "=", parseInt(resolvingactionid)];
            }
        }
        
        //REMOVE ROW SELECTION
        if (state && state.selectedRowKeys) { delete state.selectedRowKeys };
        if (window.location.hash === "#subscription" && this.props.activeMailSubscription) {
            //if subscription view, apply filter to show only relevant actions (overdue or due in next X days)
            let filterNextXDays = 0;
            switch (this.props.activeMailSubscription.remindertype) {
                case "NEXT_7_DAYS":
                    filterNextXDays = 7;
                    break;
                case "NEXT_14_DAYS":
                    filterNextXDays = 14;
                    break;
                case "NEXT_21_DAYS":
                    filterNextXDays = 21;
                    break;
                case "NEXT_30_DAYS":
                    filterNextXDays = 30;
                    break;
                default:
                    break;
            }
            let dateFilter = ["_8", "<", moment().add(filterNextXDays, 'days').endOf('day').toDate()];
            if (this.props.activeMailSubscription.coverage === "MY_PARTY") {
                state.filterValue = [['actionmatchesmyparty', '=', true], "and", dateFilter];
            }
            else {
                state.filterValue = dateFilter;
            }
            return state;
        }
        else {
            return state;
        }
    }
    render() {
        return (
            <Portlet>
                <PortletBody >
                    <DataGrid
                        ref={this.gridRef}
                        height={'67vh'}
                        dataSource={this.props.actionsList}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        columnResizingMode='widget'
                        onRowRemoving={this.onRowRemoving}
                        style={{ width: '100%', height: '100%', maxHeight: '67vh' }}
                        name="ActionsDashboard"
                        keyExpr="_1"
                        onExporting={this.onExporting}
                        loadPanel={{ enabled: false }}
                        onRowPrepared={this.onRowPrepared}
                    >

                        <HeaderFilter visible={true} />
                        <FilterPanel visible={true} />
                        <FilterRow applyFilter="auto" visible={true} />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />


                        <StateStoring
                            enabled={true}
                            type="custom"
                            customSave={this.customSaveState}
                            customLoad={this.customLoadState}
                        />

                        <Export enabled={true} fileName={this.props.intl.formatMessage({ id: 'GENERAL.ACTIONS.TITLE' })} />
                        <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.ACTION_ID" })}
                            dataField="_1"
                            visible={false}

                        />
                        <Column
                            name="Contract ID"
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.FIELD.ID" })}
                            dataField="_2"
                            visible={false}
                        />
                        <Column
                            name="Contract Name"
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.FIELD.NAME" })}
                            dataField="_2"
                            visible={true}
                            lookup={{ dataSource: this.props.contractOptions, valueExpr: 'contractid', displayExpr: 'name' }}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.OWNER_PARTY" })}
                            dataField="_6"
                            lookup={{ dataSource: this.genericPartyNames, valueExpr: 'id', displayExpr: 'display' }}
                            allowHiding={false}
                            minWidth={150}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.MY_PARTY" })}
                            dataField="mycontractparty"
                            lookup={{ dataSource: this.genericPartyNames, valueExpr: 'id', displayExpr: 'display' }}
                            // allowHiding={false}
                            minWidth={150}
                            visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.ACTION_IS_FOR_MY_PARTY" })}
                            dataField="actionmatchesmyparty"
                            dataType="boolean"
                            visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.GROUP_CATEGORY" })}
                            dataField="_15"
                            lookup={{ dataSource: this.actionGroupCategories, valueExpr: 'value', displayExpr: 'display' }}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.SUBJECT" })}
                            dataField="_5"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_DATE" })}
                            dataField="_4"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                            visible={false}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.DUE_DATE" })}
                            dataField="_8"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.OVERDUE" })}
                            dataField="_7"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_BY_REFERENCE" })}
                            dataField="_11"
                            cellRender={this.renderCreateByReference}
                        />



                        <Column
                            name="completeButton"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button
                                name="action"
                                hint={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.COMPLETE" })}
                                icon="link"
                                // visible={true}
                                disabled={false}
                                onClick={this.completeIconClicked}
                                visible={true}//{this.isCompleteIconVisible}
                            />
                        </Column>
                        <Summary >
                            <TotalItem
                                column="_6"
                                summaryType="count"
                            />
                            <TotalItem
                                column="_7"
                                summaryType='sum'
                                displayFormat="Ovd: {0}"
                            />


                        </Summary>

                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                        <Toolbar>
                            <ToolbarItem location="before">
                                <div>
                                    <h3 style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                                        <FormattedMessage id='GENERAL.ACTIONS.TITLE' />
                                    </h3>
                                </div>
                            </ToolbarItem>


                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                options={{
                                    icon: "refresh",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.REFRESH" }),
                                    onClick: this.props.loadActions.bind(this, true), // force reload
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                visible={isCalendarSubscriptionEnabled}
                                options={{
                                    icon: "addtableheader",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.EXPORT_ICS" }),
                                    onClick: this.onCalendarSubscriptClick,
                                }}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                visible={isActionMailSubscriptionEnabled}
                                options={{
                                    icon: "email",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.SUBSCRIBE_EMAIL_REMINDERS" }),
                                    onClick: this.onEmailSubscriptClick,
                                }}
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="exportButton"
                            />
                            {/* <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="applyFilterButton"
                            /> */}
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="columnChooserButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="searchPanel"
                            />
                        </Toolbar>
                    </DataGrid>
                    <ActionsCalendarSubscriptionWizard
                        visible={this.state.showCalendarSubscriptionWizard}
                        onDialogResult={this.onCalendarSubscriptionWizardDialogResult}
                    />
                    <ActionsEmailSubscriptionWizard
                        visible={this.state.showEmailSubscriptionWizard}
                        onDialogResult={this.onEmailSubscriptionWizardDialogResult}
                    />
                </PortletBody>

            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    userProfile: store.auth.userProfile,
    actionsList: store.actions.actionsList,
    contractOptions: store.actions.contractOptions

});

const mapDispatchToProps = {
    loadActions: actionsDuck.actions.fetchStart
}

export default injectIntl(withRouter(withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ActionsGrid))));
